// @flow
import React from 'react'
import { Typography, Collapse, Grid } from '@material-ui/core'
import { toUpper } from 'lodash/string'
import i18n from 'i18next'
import { ExpandMore, ExpandLess } from '@material-ui/icons'

import Link from '../../../../../components/Link'
import styles, { DEFAULT_FONT_SIZE } from './styles.js'

type Props = {
  activeCategory: string,
  category: string,
  color: string,
  catalogID?: string,
  products: Array<Object>,
  productID: number,
  toggleActiveCategory: Function
}

const CategoryList = (props: Props) => {
  const isCategoryActive = props.activeCategory === props.category
  const isCatalogActive = props.catalogID === props.category
  const isProductActive = productID => {
    return i18n.t(productID) === props.productID
  }

  return (
    <div style={styles.container}>
      <Grid
        container
        direction='row'
        justify='flex-start'
        style={styles.category}
        onClick={() =>
          props.toggleActiveCategory(isCategoryActive ? 'none' : props.category)
        }
      >
        <Typography
          gutterBottom
          style={styles.categoryTitle(props.color, DEFAULT_FONT_SIZE)}
        >
          {toUpper(i18n.t(`catalog.type.${props.category}`))}
        </Typography>
        {isCategoryActive ? <ExpandLess /> : <ExpandMore />}
      </Grid>
      <Collapse in={props.activeCategory === props.category}>
        {props.products.map((product, idx) => {
          return (
            !product.hideFromSite && (
              <Link
                key={idx}
                to={i18n
                  .t('routes.PRODUCT')
                  .replace(':productID', i18n.t(product.productID))
                  .replace(':slug', i18n.t(product.slug))}
                style={styles.anchor(props.color)}
              >
                <Typography
                  style={styles.text(
                    isProductActive(product.productID),
                    props.color,
                    DEFAULT_FONT_SIZE
                  )}
                  className='hoverBold'
                >
                  {i18n.t(`${product.title}`)}
                </Typography>
              </Link>
            )
          )
        })}
        {props.products.length > 1 && (
          <Link
            to={i18n.t('routes.CATALOG').replace(':type', props.category)}
            style={styles.anchor(props.color)}
          >
            <Typography
              style={styles.text(
                isCatalogActive,
                props.color,
                DEFAULT_FONT_SIZE
              )}
              className='hoverBold'
            >
              {i18n.t(`catalog.seeEverything.${props.category}`)}
            </Typography>
          </Link>
        )}
      </Collapse>
    </div>
  )
}

export default CategoryList
